const POPUP_WINDOW_WIDTH = 600;
const POPUP_WINDOW_HEIGHT = 650;
export const getNewWindowFeatures = _ref => {
  let {
    isAdvancedOauthApp,
    avoidPostInstallation
  } = _ref;
  if (isAdvancedOauthApp && avoidPostInstallation) {
    return getPopupFeatures();
  }
  return;
};
const getPopupFeatures = () => {
  const top = getMiddleCoordinate(window.screen.height, POPUP_WINDOW_HEIGHT);
  const left = getMiddleCoordinate(window.screen.width, POPUP_WINDOW_WIDTH);
  return `height=${POPUP_WINDOW_HEIGHT},width=${POPUP_WINDOW_WIDTH},top=${top},left=${left}`;
};
const getMiddleCoordinate = (screenSize, popupWindowSize) => screenSize / 2 - popupWindowSize / 2;
//# sourceMappingURL=getNewWindowFeatures.js.map